module.exports = __webpack_public_path__ + "static/img/img37.52c5b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img37.png
// module id = zQIp
// module chunks = 1